import { createFileRoute } from "@tanstack/react-router";
import { AddDiaryConsentForm } from "@/features/patients/update/AddDiaryConsentForm";

const AddConsentPage = () => {
    const { diaryId } = Route.useParams();
    return (
        <div className="space-y-8 min-w-0 max-w-3xl">
            <AddDiaryConsentForm diaryId={diaryId} />
        </div>
    );
};

export const Route = createFileRoute("/_app/patients/$diaryId/update/consent")({
    component: AddConsentPage,
});
